package one.healthium.health_log.ui

import one.healthium.domain.health_log.models.HealthLogAnswerModel
import one.healthium.domain.health_log.models.HealthLogModel
import one.healthium.domain.health_log.models.HealthLogQuestionModel
import one.healthium.health_log.ui.models.HealthLogQuestionUiModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class HealthLogUiState(
    val loading: Boolean = false,
    val saveInProgress: Boolean = false,
    val questions: List<HealthLogQuestionModel>? = null,
    val todayHealthLog: HealthLogModel? = null,
    val selectedAnswers: Map<String, HealthLogAnswerModel?> = emptyMap(),
) {
    val uiData: List<HealthLogQuestionUiModel>? = questions?.map { questionModel ->
        val isSelected =
            // this logic is needed for case when user wants to deselect an option, in this case selectedAnswers will contain the question id with null value
            if (selectedAnswers.containsKey(questionModel.id)) {
                selectedAnswers[questionModel.id]
            } else {
                todayHealthLog?.answers?.firstOrNull { it.questionId == questionModel.id }?.answers?.let { answers ->
                    questionModel.answers.firstOrNull {
                        answers.any { answer -> answer.answerId == it.id }
                    }
                }
            }

        HealthLogQuestionUiModel(
            model = questionModel,
            selectedOption = isSelected,
        )
    }
}
